import { Api } from '@/modules'

import LoadingImg from '@/assets/images/load.gif'

import { Img, ImageWidth, CanalLink, ChannelNameText, DefaultChannelIcon } from './TableImage.styles'
import { Flex } from '..'

export type TableImageProps = ImageWidth & {
  id?: string
  hyperlink?: string
}

export function TableImage({ id, hyperlink, $width }: TableImageProps): JSX.Element | null {
  if (!id) return null
  if (hyperlink) {
    return (
      <a href={hyperlink} target="_blank" rel="noreferrer">
        <Image id={id} $width={$width} />
      </a>
    )
  }
  return <Image id={id} $width={$width} />
}

function Image({ id, $width }: { id: string } & ImageWidth): JSX.Element {
  if (id === 'default-logo-color') {
    return <Img alt="logo" src={process.env.REACT_APP_DEFAULT_LOGO_COLOR} $width={$width} />
  }
  if (id === 'default-logo-gray') {
    return <Img alt="logo" src={process.env.REACT_APP_DEFAULT_LOGO_GRAY} $width={$width} />
  }

  const [, , logo] = Api.Query<string>(`files/${id}`)
  return <Img alt="logo" src={logo ?? LoadingImg} $width={$width} />
}

export type CanalProps = ImageWidth & {
  hyperlink: string
  channelImage?: string
  brandImage?: string
  brandName: string
  channelName?: string
}

export function Canal({
  hyperlink,
  brandName,
  channelImage,
  brandImage,
  channelName,
  $width,
}: CanalProps): JSX.Element {
  return (
    <Flex $type="column" $justify="center" $align="center" $gap={4}>
      <CanalLink href={hyperlink} target="_blank" rel="noreferrer">
        {channelImage ?
          <Img alt="canal" src={channelImage} $width={$width} />
        : <DefaultChannelIcon $width={$width} />}
      </CanalLink>

      {channelName && <ChannelNameText title={channelName}>{channelName}</ChannelNameText>}

      {brandImage ?
        <Img src={brandImage} $width={$width} />
      : <span>{brandName}</span>}
    </Flex>
  )
}
